import React, { useEffect } from 'react'
import { DrawerHeader } from '../DrawerHeader/DrawerHeader'

interface DrawerProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  children: React.ReactNode
  /** pinned below the scrollable content */
  footer?: React.ReactNode
}

/** Right-side slide-in panel (same pattern as NavBar/UserProfileDrawer drawers). */
export const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose, title, children, footer }) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = ''
    }
  }, [isOpen, onClose])

  return (
    <>
      {/* above the fixed navbar (z-50) so the whole page dims behind the drawer */}
      <div
        className={`fixed inset-0 bg-gray-500/75 transition-opacity z-[60] ${
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={onClose}
        aria-hidden="true"
      />

      <div
        className={`fixed inset-y-0 right-0 z-[70] flex transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="relative w-screen sm:max-w-md">
          <div className="flex h-full flex-col bg-white shadow-xl">
            <DrawerHeader title={title} onClose={onClose} />
            <div className="flex-1 overflow-y-auto">{children}</div>
            {footer && <div className="border-t border-gray-200 p-4">{footer}</div>}
          </div>
        </div>
      </div>
    </>
  )
}
